/**
 * Single source of truth for Pro plan pricing shown in the UI.
 *
 * Verified against the live Stripe price objects (monthly 19900 = $199/mo,
 * annual 189900 = $1,899/yr). Every surface that quotes a Pro price — the
 * Pricing page, the at-limit UpgradeModal, the PlanComparisonModal — must
 * read these so they can't drift apart (they previously showed the annual
 * discount three different ways: 15% / 20% / a fabricated $2,030 total).
 *
 * If the Stripe prices change, update them here (and in Stripe) in lockstep.
 */

export const PRO_MONTHLY = 199;
export const PRO_ANNUAL_TOTAL = 1899;
export const PRO_ANNUAL_PER_MONTH = Math.round(PRO_ANNUAL_TOTAL / 12); // 158

/** Whole-percent annual discount vs paying monthly for 12 months (= 20). */
export const PRO_ANNUAL_SAVINGS_PCT = Math.round(
  ((PRO_MONTHLY * 12 - PRO_ANNUAL_TOTAL) / (PRO_MONTHLY * 12)) * 100
);

/** Dollars saved per year by choosing annual over monthly (= 489). */
export const PRO_ANNUAL_SAVINGS_TOTAL = PRO_MONTHLY * 12 - PRO_ANNUAL_TOTAL;

/** Dollars saved per month, amortized, by choosing annual (= 41). */
export const PRO_ANNUAL_SAVINGS_PER_MONTH = PRO_MONTHLY - PRO_ANNUAL_PER_MONTH;

// ── Prosumer ($19/mo · $182/yr) ─────────────────────────────────────────────
// The consumer-conversion tier: 5 cited summaries/mo + research tool. Live
// Stripe prices must be created in the dashboard; their IDs go into the edge
// functions as STRIPE_PROSUMER_MONTHLY_PRICE_ID / STRIPE_PROSUMER_ANNUAL_PRICE_ID.
export const PROSUMER_MONTHLY = 19;
export const PROSUMER_ANNUAL_TOTAL = 182;
export const PROSUMER_ANNUAL_PER_MONTH = Math.round(PROSUMER_ANNUAL_TOTAL / 12); // 15
export const PROSUMER_ANNUAL_SAVINGS_PCT = Math.round(
  ((PROSUMER_MONTHLY * 12 - PROSUMER_ANNUAL_TOTAL) / (PROSUMER_MONTHLY * 12)) * 100
);
export const PROSUMER_SUMMARY_LIMIT = 5;
export const PROSUMER_FOLLOW_LIMIT = 25;
